<template>
  <v-container class="px-4 py-6">
    <h1 style="font-family: 'montserrat-semibold';">Balances</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-autocomplete
          :label="'Selecciona una currency'"
          :items="currencies"
          hide-details
          style="font-family: 'montserrat-medium'; border-radius: 20px;"
          outlined
          class="mr-2"
          color="black"
          item-value="sValue"
          item-text="sName"
          @change="getBalance()"
          v-model="selectedCurrency"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="loading" />
    <v-data-table class="d-none d-sm-block" :items-per-page="5" v-else hide-default-header :items="balances" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Monto" }}</th>                                                                                                                                                                               
            <th class="header__title right">{{ "Fecha" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ "$ " + formatMoney(item.balance) + " " + (item.currency ? item.currency : "") }}</td>
            <td class="table__item">{{ formatDate(item.created_at) }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "Balances",
    props: {
      activeTab: String,
      enterprise: Object,
      permissionList: Array,
    },
    data() {
      return {
        balances: [],
        selectedCurrency: "USD",
        currencies: [
          { sName: "USD", sValue: "USD" },
          { sName: "MXN", sValue: "MXN" },
        ],
        loading: false,
      }
    },
    watch: {
      activeTab(val) {
        if (val === 'balances') {
          this.getBalance();
        }
      }
    },
    mounted() {
      if (this.activeTab === 'balances') {
        this.getBalance();
      }
    },
    methods: {
      async getBalance() {
        this.loading = true;
        this.balances = [];

        DB.get(`${URI}/api/v1/en/administrator/balances/${this.$route.params.sEnterpriseId}/${this.selectedCurrency}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.balances = response.data.balances;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      }
    }
  }
</script>
<style scoped>
</style>